import React from 'react'
import { toast } from 'react-toastify'
import { CircleLoader, FullBlockLoader } from '@deal/components'
import { ChildProps, WithApolloClient, withApollo } from 'react-apollo'
import { withAnalytics, WithAnalyticsProps } from '#src/containers/Analytics'
import { getFilteredLineItems } from '#src/services/cart'
import {
  TrackableSellableFragment,
  SyncShoppingCartMutation,
  RemoveItemFromOrderComponent
} from '#src/generated/graphql'
import { CartConsumer } from '#src/containers/Cart'
import { getSellableEcommerceProperties } from '#src/services/tracking'
import LineItems from './components/LineItems'
import EmptyCart from './components/EmptyCart'
import CartAlerts from './components/CartAlerts'
import Footer from './components/Footer'
// @ts-ignore TODO: Write typings for react-scrolllock
import { TouchScrollable } from 'react-scrolllock'
import styles from './styles.css'

interface CartContainerProps {}

const CartContainer: React.SFC<
  ChildProps<WithApolloClient<CartContainerProps & WithAnalyticsProps>, SyncShoppingCartMutation>
> = ({ analytics }) => {
  return (
    <CartConsumer>
      {({ order }) => {
        if (order) {
          const filteredLineItems = getFilteredLineItems(order.lineItems)

          return (
            <div className={styles.content}>
              <div>
                <CartAlerts messages={order.messages} />
              </div>
              <TouchScrollable>
                <div className={styles.items}>
                  {filteredLineItems.length > 0 ? (
                    <RemoveItemFromOrderComponent
                      onError={() => {
                        toast.error('Error removing item from cart.')
                      }}
                    >
                      {removeItemsFromOrder => (
                        <LineItems
                          lineItems={filteredLineItems}
                          onRemoveItem={(lineItemId, sellable?: TrackableSellableFragment) => {
                            removeItemsFromOrder({
                              variables: {
                                input: {
                                  lineItemIds: [lineItemId]
                                }
                              }
                            }).then(() => {
                              sellable &&
                                analytics &&
                                analytics.productRemoved(getSellableEcommerceProperties(sellable))
                            })
                          }}
                        />
                      )}
                    </RemoveItemFromOrderComponent>
                  ) : (
                    <EmptyCart />
                  )}
                </div>
              </TouchScrollable>
              {filteredLineItems.length > 0 && (
                <div className={styles.footer}>
                  <Footer order={order} />
                </div>
              )}
            </div>
          )
        } else {
          return <FullBlockLoader loader={CircleLoader} />
        }
      }}
    </CartConsumer>
  )
}

export default withApollo(withAnalytics(CartContainer))
